// extracted by mini-css-extract-plugin
export default {"notFoundPage":"NotFound_not-found-page__UevJk","title":"NotFound_title__rre8M","description":"NotFound_description__SCYdR","btnBack":"NotFound_btn-back__8p2Ds"};